export enum HttpStatusEnum {
    ERROR = 'ERROR',
    SUCCESS = 'SUCCESS',
    UNDEFINED = 'UNDEFINED',
    NEED_USER_CONFIRMATION = 'NeedUserConfirmationException',
}
